(function () {
  const ICONS = {
    badge: '<path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>',
    check: '<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 16v-4m0-4h.01"/>',
    chevron: '<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>',
    arrow: '<path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"/>',
    phone: '<path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>',
    cart: '<circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M3 4h2l2.2 10.4a2 2 0 0 0 2 1.6h8.4a2 2 0 0 0 2-1.6L21 8H7"/>',
    gauge: '<path d="M4 20h16M7 20v-6M12 20v-10M17 20v-14"/>',
    links: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
    sliders: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>',
    shield: '<circle cx="12" cy="12" r="9"/><path stroke-linecap="round" stroke-linejoin="round" d="M8.5 12.5l2.5 2.5 5-5"/>',
  };

  function initFinder(root) {
    const apiBase = (root.dataset.api || "/apps/part-finder").replace(/\/$/, "");
    const resultsOnly = root.dataset.role === "results";
    const heading = root.dataset.heading || (resultsOnly ? "Matching parts" : "Find your part by");
    const headingAccent = root.dataset.headingAccent || (resultsOnly ? "" : "Brand and model");
    const intro = root.dataset.intro || (resultsOnly
      ? "Adjust the saw if you need a different match. The parts for that search stay on this page."
      : "Select your equipment details below or look up an existing manufacturer part number to get guaranteed compatible chains, bars, and sprockets.");
    const kickerText = root.dataset.kicker || (resultsOnly ? "Longer Chainsaws" : "Official equipment fitment finder");
    const findLabel = root.dataset.find || (resultsOnly ? "Find parts" : "Find it");
    const clearLabel = root.dataset.clear || "Clear";

    const state = {
      index: null,
      brandKey: "",
      modelKey: "",
      length: "",
      pitchKey: "",
      gaugeKey: "",
      searching: false,
    };

    const tips = {
      brand: "Choose the manufacturer of your power equipment.",
      model: "Enter or select your equipment's model number found on its label.",
      length: "The usable cutting length stamped onto the base of your guide bar.",
      pitch: "Optional chain pitch preference.",
      gauge: "Optional chain gauge preference.",
    };

    root.innerHTML = "";
    const shell = el("div", "lpf-shell");

    const brand = combo("brand", "2", "1", "Select brand", "Select brand", true);
    const model = combo("model", "3", "2", "Select model", "Select model number", true);
    const length = combo("length", "4", "3", "Select bar length", "Select bar length", true);
    const pitch = combo("pitch", "", "4", "Chain Pitch", "Pitch", false);
    const gauge = combo("gauge", "", "5", "Gauge", "Gauge", false);
    pitch.field.classList.add("is-optional");
    gauge.field.classList.add("is-optional");

    brand.getOptions = () => state.index ? state.index.brands.map((item) => ({ key: item.key, label: item.label })) : [];
    model.getOptions = () => {
      const selected = currentBrand();
      return selected ? selected.models.map((item) => ({ key: item.key, label: item.label })) : [];
    };
    length.getOptions = () => {
      const selected = currentModel();
      return selected ? selected.lengths.map((item) => ({ key: item.value, label: item.value })) : [];
    };
    pitch.getOptions = () => {
      const selected = currentLength();
      const pitches = selected ? selected.pitches.map((item) => ({ key: item.key, label: item.label })) : [];
      return [{ key: "", label: "Any pitch" }, ...pitches];
    };
    gauge.getOptions = () => {
      const selected = currentLength();
      let gauges = selected?.gauges || [];
      if (state.pitchKey) gauges = gauges.filter((item) => (item.pitches || []).includes(state.pitchKey));
      return [{ key: "", label: "Any gauge" }, ...gauges.map((item) => ({ key: item.key, label: item.label }))];
    };

    const error = el("p", "lpf-error");
    error.hidden = true;

    const find = el("button", "lpf-find");
    find.type = "submit";
    const findLabelEl = el("span", "lpf-find-label", findLabel);
    find.append(findLabelEl, icon("arrow", "lpf-find-icon", "2.5"));

    const clear = el("button", "lpf-text-btn", clearLabel);
    clear.type = "button";

    const preset = el("div", "lpf-preset");
    preset.append(document.createTextNode("Preset matching: "));
    const presetStrong = el("strong", "");
    preset.append(presetStrong);

    const formActions = el("div", "lpf-form-actions");
    const sideActions = el("div", "lpf-side-actions");
    const formGrid = el("div", "lpf-form-grid");
    const pitchSlot = el("div", "lpf-pitch-slot");
    const sideFields = el("div", "lpf-side-fields");
    const results = el("div", "lpf-results");
    results.setAttribute("aria-live", "polite");
    const chipsRow = el("div", "lpf-chips");
    const tabsScroller = el("div", "lpf-tabs-scroller");
    const tabs = el("div", "lpf-tabs");
    tabsScroller.append(tabs);
    const specbar = el("footer", "lpf-specbar");
    specbar.hidden = true;
    chipsRow.hidden = true;
    tabsScroller.hidden = true;
    const mobileName = el("span", "lpf-mobile-name", "Select a saw");
    const mobileCount = el("span", "lpf-mobile-count", "");
    mobileCount.hidden = true;
    const editLabel = el("span", "", "Edit Saw");
    const oemText = el("p", "");
    const formStatus = el("p", "lpf-status");
    formStatus.hidden = true;

    let formPage = null;
    if (!resultsOnly) formPage = buildFormPage();
    const resultsLayout = buildResultsLayout();
    const toast = buildToast();

    shell.append(resultsLayout);
    if (formPage) shell.prepend(formPage);
    root.append(shell, toast);

    showLayout(resultsOnly || shouldRestoreResults() ? "results" : "form");
    if (shouldRestoreResults()) showLoading();

    brand.onChange = (key) => {
      state.brandKey = key;
      state.modelKey = "";
      state.length = "";
      state.pitchKey = "";
      state.gaugeKey = "";
      model.clear();
      length.clear();
      pitch.clear();
      gauge.clear();
      syncDisabled();
    };
    model.onChange = (key) => {
      state.modelKey = key;
      state.length = "";
      state.pitchKey = "";
      state.gaugeKey = "";
      length.clear();
      pitch.clear();
      gauge.clear();
      syncDisabled();
    };
    length.onChange = (key) => {
      state.length = key;
      state.pitchKey = "";
      state.gaugeKey = "";
      pitch.setKey("");
      gauge.setKey("");
      syncDisabled();
    };
    pitch.onChange = (key) => {
      state.pitchKey = key;
      retainGauge();
      syncDisabled();
    };
    gauge.onChange = (key) => {
      state.gaugeKey = key;
      syncDisabled();
    };

    find.addEventListener("click", (event) => {
      event.preventDefault();
      runSearch(true);
    });
    clear.addEventListener("click", resetAll);
    loadIndex();

    function buildFormPage() {
      const page = el("div", "lpf-form-page");
      const hero = el("div", "lpf-hero");
      const title = el("h1", "");
      title.append(document.createTextNode(heading));
      if (headingAccent) title.append(el("span", "lpf-heading-accent", headingAccent));
      hero.append(title);

      const card = el("div", "lpf-form-card");
      const pad = el("div", "lpf-card-pad");
      // const head = el("div", "lpf-card-head");
      // const headCopy = el("div", "");
      // headCopy.append(el("span", "lpf-option", "Option 1"), el("h2", "", "Brand & Model Search"));
      // head.append(headCopy, el("span", "lpf-required-note", "* Required fields"));

      // const typeWrap = el("div", "lpf-part-type");
      // const typeLabel = el("div", "lpf-type-label");
      // typeLabel.append(el("span", "lpf-step", "1"), document.createTextNode("Select Replacement Part Type "), el("span", "lpf-req", "*"));
      // const typeCard = el("div", "lpf-type-card");
      // const typeCheck = el("div", "lpf-type-check");
      // typeCheck.append(icon("check", "", "2.5"));
      // const typeIcon = el("div", "lpf-type-icon");
      // typeIcon.append(sawIcon());
      // typeCard.append(typeCheck, typeIcon, el("span", "lpf-type-name", "Saw Chain, Guide Bars & Sprockets"));
      // typeWrap.append(typeLabel, typeCard);

      const filterBox = el("div", "lpf-filter-box");
      const filterHead = el("div", "lpf-filter-head");
      filterHead.append(
        el("span", "lpf-filter-title", "Optional specifications (filters)"),
        el("span", "lpf-filter-note", ""),
      );
      filterBox.append(filterHead, pitchSlot);

      formActions.append(preset, find);
      pad.append(formGrid, filterBox, error, formActions);
      card.append(pad);

      page.append(hero, card, formStatus);
      return page;
    }

    function buildResultsLayout() {
      const layout = el("div", "lpf-results-layout");
      const mobile = el("div", "lpf-mobile-bar");
      const saw = el("div", "lpf-mobile-saw");
      saw.append(el("span", "lpf-dot"), mobileName, mobileCount);
      const edit = el("button", "lpf-edit");
      edit.type = "button";
      edit.append(icon("sliders"), editLabel);
      edit.addEventListener("click", toggleSidebar);
      mobile.append(saw, edit);

      const grid = el("div", "lpf-results-grid");
      const sidebar = el("aside", "lpf-sidebar");
      const sideCard = el("div", "lpf-side-card");
      const kickerRow = el("div", "lpf-side-kicker-row");
      const close = el("button", "lpf-side-close", "✕");
      close.type = "button";
      close.setAttribute("aria-label", "Close filters");
      close.addEventListener("click", () => sidebar.classList.remove("is-open"));
      kickerRow.append(el("span", "lpf-side-kicker", kickerText), close);
      sideActions.append(find, clear);
      const sideForm = el("div", "lpf-side-form");
      sideForm.append(sideFields, error, sideActions);
      const oem = el("div", "lpf-oem");
      oem.append(icon("shield"), oemText);
      sideCard.append(kickerRow, el("h1", "", heading), el("p", "lpf-side-intro", intro), sideForm, oem);
      sidebar.append(sideCard);

      const main = el("div", "lpf-main");
      main.append(chipsRow, tabsScroller, results, specbar);
      grid.append(sidebar, main);
      layout.append(mobile, grid);
      layout.sidebar = sidebar;
      return layout;
    }

    function buildToast() {
      const box = el("div", "lpf-toast");
      box.setAttribute("role", "status");
      const mark = el("div", "lpf-toast-icon");
      mark.append(icon("check", "", "2.5"));
      const text = el("span", "");
      box.append(mark, text);
      box._text = text;
      return box;
    }

    function showLayout(mode) {
      const resultsMode = mode === "results" || resultsOnly;
      root.classList.toggle("is-form-view", !resultsMode);
      root.classList.toggle("is-results-view", resultsMode);
      if (formPage) formPage.hidden = resultsMode;
      resultsLayout.hidden = !resultsMode;
      if (resultsMode) {
        sideFields.append(brand.field, model.field, length.field, pitch.field, gauge.field);
        sideFields.after(error);
        sideActions.append(find, clear);
        [brand, model, length, pitch, gauge].forEach((field) => field.setPresentation("results"));
      } else {
        formGrid.append(brand.field, model.field, length.field);
        pitchSlot.append(pitch.field, gauge.field);
        formActions.before(error);
        formActions.append(preset, find);
        [brand, model, length, pitch, gauge].forEach((field) => field.setPresentation("form"));
      }
      const sectionEl = root.closest(".shopify-section");
      if (sectionEl && !resultsOnly) sectionEl.style.background = resultsMode ? "#ECEEF2" : "#F1F3F6";
      refreshSummary();
    }

    function toggleSidebar() {
      const sidebar = resultsLayout.sidebar;
      const open = sidebar.classList.toggle("is-open");
      editLabel.textContent = open ? "Close" : "Edit Saw";
      if (open) sidebar.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    function closeSidebar() {
      resultsLayout.sidebar.classList.remove("is-open");
      editLabel.textContent = "Edit Saw";
    }

    function currentBrand() {
      return state.index?.brands.find((item) => item.key === state.brandKey) || null;
    }
    function currentModel() {
      return currentBrand()?.models.find((item) => item.key === state.modelKey) || null;
    }
    function currentLength() {
      return currentModel()?.lengths.find((item) => item.value === state.length) || null;
    }

    function syncDisabled() {
      model.setDisabled(!state.brandKey);
      length.setDisabled(!state.modelKey);
      pitch.setDisabled(!state.length);
      gauge.setDisabled(!state.length);
      refreshSummary();
    }

    function retainGauge() {
      const allowed = new Set(gauge.getOptions().map((item) => item.key));
      if (state.gaugeKey && !allowed.has(state.gaugeKey)) {
        state.gaugeKey = "";
        gauge.setKey("");
      }
    }

    function refreshSummary() {
      const brandLabel = brand.currentLabel();
      const modelLabel = model.currentLabel();
      const barLabel = length.currentLabel();
      const barName = barSummary(barLabel);
      presetStrong.textContent = [brandLabel || "—", modelLabel || "—", barName || "—"].join(" • ");
      const short = lengthShort(barLabel);
      const name = [brandLabel, modelLabel].filter(Boolean).join(" ");
      mobileName.textContent = name ? `${name}${short ? ` (${short})` : ""}` : "Select a saw";
      oemText.replaceChildren();
      if (brandLabel && modelLabel && barLabel) {
        const bar = lengthPhrase(barLabel);
        oemText.append(el("span", "lpf-oem-title", `${brandLabel} ${modelLabel} | ${bar} bar`));
        oemText.append(el("span", "lpf-oem-note", "Matching chains, guide bars and accessories. Verify specifications before ordering."));
      } else {
        oemText.textContent = "Select a brand, model, and bar length.";
      }
    }

    function shouldRestoreResults() {
      const params = new URLSearchParams(location.search);
      if (!params.get("brand") || !params.get("model") || !params.get("length")) return false;
      if (root.dataset.behavior === "page" && root.dataset.resultsUrl && !onResultsPage()) return false;
      return true;
    }

    function showLoading() {
      showLayout("results");
      shell.classList.add("is-loading");
      root.setAttribute("aria-busy", "true");
      chipsRow.replaceChildren();
      chipsRow.hidden = true;
      tabsScroller.hidden = true;
      specbar.hidden = true;
      const card = el("div", "lpf-section lpf-loading");
      card.setAttribute("role", "status");
      const head = el("div", "lpf-loading-head");
      const spinner = el("span", "lpf-spinner");
      spinner.setAttribute("aria-hidden", "true");
      head.append(spinner, el("p", "lpf-loading-label", "Finding parts…"));
      card.append(head);
      for (let index = 0; index < 4; index += 1) {
        const row = el("div", "lpf-skeleton");
        const copy = el("span", "lpf-skeleton-copy");
        copy.append(el("span", ""), el("span", ""), el("span", ""));
        row.append(el("span", "lpf-skeleton-photo"), copy);
        card.append(row);
      }
      results.replaceChildren(card);
      find.disabled = true;
      findLabelEl.textContent = "Matching...";
    }

    function stopRestore() {
      if (!shell.classList.contains("is-loading")) return;
      shell.classList.remove("is-loading");
      root.removeAttribute("aria-busy");
      results.replaceChildren();
      find.disabled = false;
      findLabelEl.textContent = findLabel;
      if (!resultsOnly) showLayout("form");
    }

    async function loadIndex() {
      const restoring = shell.classList.contains("is-loading");
      if (!restoring && formStatus) {
        formStatus.hidden = false;
        formStatus.textContent = "Loading the catalogue…";
      }
      try {
        const response = await fetch(`${apiBase}/index`);
        const data = await response.json();
        if (!response.ok || data.ok === false) throw new Error(data.error || "The catalogue could not be loaded.");
        state.index = data;
        if (formStatus) formStatus.hidden = true;
        if (data.empty) {
          shell.classList.remove("is-loading");
          root.removeAttribute("aria-busy");
          const message = el("p", "lpf-help", "The part finder has no catalogue yet. Upload the master sheet in the app admin.");
          if (resultsOnly) results.replaceChildren(message);
          else if (formStatus) {
            formStatus.hidden = false;
            formStatus.textContent = message.textContent;
            showLayout("form");
          }
          brand.setDisabled(true);
          find.disabled = false;
          findLabelEl.textContent = findLabel;
          return;
        }
        if (!restoring) results.replaceChildren();
        syncDisabled();
        if (resultsOnly && !new URLSearchParams(location.search).get("brand")) {
          results.append(el("p", "lpf-help", "Search for a saw. Matching parts show on this page."));
          chipsRow.hidden = true;
          tabsScroller.hidden = true;
        }
        applyQuery();
      } catch (loadError) {
        shell.classList.remove("is-loading");
        root.removeAttribute("aria-busy");
        find.disabled = false;
        findLabelEl.textContent = findLabel;
        const message = loadError.message || "The catalogue could not be loaded.";
        if (resultsOnly || shell.classList.contains("is-results")) results.replaceChildren(el("p", "lpf-help", message));
        else if (formStatus) {
          formStatus.hidden = false;
          formStatus.textContent = message;
        }
      }
    }

    function applyQuery() {
      const params = new URLSearchParams(location.search);
      const brandKey = params.get("brand") || "";
      const modelKey = params.get("model") || "";
      const barLength = params.get("length") || "";
      const pitchKey = params.get("pitch") || "";
      const gaugeKey = params.get("gauge") || "";
      if (!brandKey || !state.index.brands.some((item) => item.key === brandKey)) {
        stopRestore();
        return;
      }
      state.brandKey = brandKey;
      brand.setKey(brandKey);
      if (modelKey && currentBrand()?.models.some((item) => item.key === modelKey)) {
        state.modelKey = modelKey;
        model.setKey(modelKey);
      }
      if (barLength && currentModel()?.lengths.some((item) => item.value === barLength)) {
        state.length = barLength;
        length.setKey(barLength);
      }
      if (state.length) {
        state.pitchKey = pitchKey;
        pitch.setKey(pitchKey);
        state.gaugeKey = gauge.getOptions().some((item) => item.key === gaugeKey) ? gaugeKey : "";
        gauge.setKey(state.gaugeKey);
      }
      syncDisabled();
      if (!(state.brandKey && state.modelKey && state.length)) {
        stopRestore();
        return;
      }
      if (root.dataset.behavior === "page" && !onResultsPage()) {
        const target = root.dataset.resultsUrl || "";
        if (!target) return;
        const url = new URL(target, location.origin);
        url.search = location.search;
        location.replace(url.toString());
        return;
      }
      runSearch(false);
    }

    function onResultsPage() {
      const target = root.dataset.resultsUrl || "";
      if (!target) return false;
      try {
        return new URL(target, location.origin).pathname === location.pathname;
      } catch {
        return false;
      }
    }

    async function runSearch(updateUrl) {
      hideError();
      brand.setInvalid(!state.brandKey);
      model.setInvalid(Boolean(state.brandKey) && !state.modelKey);
      length.setInvalid(Boolean(state.modelKey) && !state.length);
      if (!state.brandKey || !state.modelKey || !state.length) {
        showError("Select a brand, model number, and bar length.");
        return;
      }
      const params = new URLSearchParams({ brand: state.brandKey, model: state.modelKey, length: state.length });
      if (state.pitchKey) params.set("pitch", state.pitchKey);
      if (state.gaugeKey) params.set("gauge", state.gaugeKey);
      if (updateUrl && root.dataset.behavior === "page" && !onResultsPage()) {
        const target = root.dataset.resultsUrl || "";
        if (!target) {
          showError("Choose a results page in the theme editor, and add Part Finder results to that page.");
          return;
        }
        const url = new URL(target, location.origin);
        url.search = params.toString();
        location.assign(url.toString());
        return;
      }
      if (updateUrl) history.replaceState(null, "", `${location.pathname}?${params.toString()}`);
      state.searching = true;
      showLoading();
      try {
        const searchParams = new URLSearchParams({ brand: state.brandKey, model: state.modelKey, barLength: state.length });
        if (state.pitchKey) searchParams.set("pitch", state.pitchKey);
        if (state.gaugeKey) searchParams.set("gauge", state.gaugeKey);
        const response = await fetch(`${apiBase}/search?${searchParams.toString()}`);
        const data = await response.json();
        if (!response.ok || data.ok === false) throw new Error(data.error || "The search failed.");
        renderResults(data);
        shell.classList.remove("is-loading");
        root.removeAttribute("aria-busy");
        if (updateUrl && window.innerWidth < 1024) closeSidebar();
      } catch (searchError) {
        shell.classList.remove("is-loading");
        root.removeAttribute("aria-busy");
        results.replaceChildren();
        chipsRow.hidden = true;
        tabsScroller.hidden = true;
        specbar.hidden = true;
        if (!resultsOnly && root.dataset.behavior !== "same") showLayout("form");
        showError(searchError.message || "The search failed.");
      } finally {
        state.searching = false;
        find.disabled = false;
        findLabelEl.textContent = findLabel;
      }
    }

    function resetAll() {
      state.brandKey = "";
      state.modelKey = "";
      state.length = "";
      state.pitchKey = "";
      state.gaugeKey = "";
      brand.clear();
      model.clear();
      length.clear();
      pitch.clear();
      gauge.clear();
      syncDisabled();
      hideError();
      results.replaceChildren();
      chipsRow.replaceChildren();
      tabs.replaceChildren();
      chipsRow.hidden = true;
      tabsScroller.hidden = true;
      specbar.hidden = true;
      mobileCount.hidden = true;
      shell.classList.remove("is-loading");
      root.removeAttribute("aria-busy");
      find.disabled = false;
      findLabelEl.textContent = findLabel;
      history.replaceState(null, "", location.pathname);
      showLayout(resultsOnly ? "results" : "form");
      if (resultsOnly) results.append(el("p", "lpf-help", "Search for a saw. Matching parts show on this page."));
    }

    function renderResults(data) {
      results.replaceChildren();
      renderChips(data.query);
      renderTabs(data.sections);
      mobileCount.hidden = false;
      mobileCount.textContent = `${data.total} part${data.total === 1 ? "" : "s"}`;
      for (const section of data.sections) results.append(renderSection(section));
      renderSpecbar(data.sections);
      chipsRow.hidden = false;
      tabsScroller.hidden = false;
    }

    function renderChips(query) {
      chipsRow.replaceChildren();
      chipsRow.append(el("span", "lpf-active-label", "Active match:"));
      const chips = [
        ["brand", query.brandLabel],
        ["model", query.modelLabel],
        ["length", query.barLength],
        ["pitch", query.pitchLabel || "Any pitch"],
        ["gauge", query.gaugeLabel || "Any gauge"],
      ];
      for (const [key, text] of chips) {
        if (!text) continue;
        const chip = el("span", "lpf-chip");
        chip.append(document.createTextNode(text));
        const remove = el("button", "lpf-chip-x", "✕");
        remove.type = "button";
        remove.setAttribute("aria-label", `Remove ${text}`);
        remove.addEventListener("click", () => removeChip(key));
        chip.append(remove);
        chipsRow.append(chip);
      }
      const reset = el("button", "lpf-reset", "Reset All");
      reset.type = "button";
      reset.addEventListener("click", resetAll);
      chipsRow.append(reset);
    }

    function removeChip(key) {
      if (key === "brand") {
        state.brandKey = "";
        state.modelKey = "";
        state.length = "";
        state.pitchKey = "";
        state.gaugeKey = "";
        brand.clear();
        model.clear();
        length.clear();
        pitch.clear();
        gauge.clear();
      } else if (key === "model") {
        state.modelKey = "";
        state.length = "";
        state.pitchKey = "";
        state.gaugeKey = "";
        model.clear();
        length.clear();
        pitch.clear();
        gauge.clear();
      } else if (key === "length") {
        state.length = "";
        state.pitchKey = "";
        state.gaugeKey = "";
        length.clear();
        pitch.clear();
        gauge.clear();
      } else if (key === "pitch") {
        state.pitchKey = "";
        pitch.setKey("");
        retainGauge();
      } else if (key === "gauge") {
        state.gaugeKey = "";
        gauge.setKey("");
      }
      syncDisabled();
      hideError();
      if (state.brandKey && state.modelKey && state.length) {
        runSearch(true);
        return;
      }
      history.replaceState(null, "", location.pathname);
      results.replaceChildren(el("p", "lpf-help", "Select a brand, model number, and bar length."));
      tabs.replaceChildren();
      tabsScroller.hidden = true;
      specbar.hidden = true;
      mobileCount.hidden = true;
      renderChips({
        brandLabel: brand.currentLabel(),
        modelLabel: model.currentLabel(),
        barLength: length.currentLabel(),
        pitchLabel: state.length ? (pitch.currentLabel() || "Any pitch") : "",
        gaugeLabel: state.length ? (gauge.currentLabel() || "Any gauge") : "",
      });
    }

    function renderTabs(sections) {
      tabs.replaceChildren();
      sections.forEach((section, index) => {
        const tab = el("button", "lpf-tab", section.count ? `${section.label} (${section.count})` : section.label);
        tab.type = "button";
        if (index === 0) tab.classList.add("is-active");
        tab.addEventListener("click", () => {
          tabs.querySelectorAll(".lpf-tab").forEach((item) => item.classList.remove("is-active"));
          tab.classList.add("is-active");
          document.getElementById(`${root.id}-${section.key}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        tabs.append(tab);
      });
    }

    function renderSection(section) {
      const wrap = el("section", "lpf-section");
      wrap.id = `${root.id}-${section.key}`;
      const header = document.createElement("header");
      const title = el("div", "lpf-section-title");
      title.append(el("span", "lpf-section-mark"), el("h2", "", section.label));
      header.append(title, el("span", "lpf-count", `Showing ${section.count}`));
      wrap.append(header);
      if (!section.items.length) {
        wrap.append(el("p", "lpf-empty", section.empty));
        return wrap;
      }
      const scroller = el("div", "lpf-table-wrap");
      scroller.append(buildTable(section));
      const cards = el("div", "lpf-cards");
      for (const item of section.items) cards.append(buildCard(item, section.showSpecs));
      wrap.append(scroller, cards);
      return wrap;
    }

    function buildTable(section) {
      const table = document.createElement("table");
      table.className = "lpf-table";
      const head = document.createElement("tr");
      head.append(columnHeader("Image", "lpf-col-image"), columnHeader("Part #", "lpf-col-part"), columnHeader("Product", "lpf-col-product"));
      if (section.showSpecs) {
        head.append(specHeader("pitch", "Pitch"), specHeader("gauge", "Gauge"), specHeader("links", "Links"));
      }
      head.append(columnHeader("Cart", "lpf-col-cart"));
      const thead = document.createElement("thead");
      thead.append(head);
      const tbody = document.createElement("tbody");
      for (const item of section.items) tbody.append(buildRow(item, section.showSpecs));
      table.append(thead, tbody);
      return table;
    }

    function columnHeader(label, className) {
      const cell = document.createElement("th");
      cell.scope = "col";
      if (className) cell.className = className;
      cell.textContent = label;
      return cell;
    }

    function specHeader(kind, label) {
      const cell = document.createElement("th");
      cell.scope = "col";
      cell.className = "lpf-spec-col";
      const stack = el("div", "lpf-spec-head");
      if (kind === "pitch") stack.append(el("span", "lpf-spec-tilde", "~"));
      else stack.append(icon(kind));
      stack.append(el("span", "", label));
      cell.append(stack);
      return cell;
    }

    function buildRow(item, showSpecs) {
      const row = document.createElement("tr");
      const imageCell = document.createElement("td");
      imageCell.className = "lpf-col-image";
      imageCell.append(photoBox(item));
      const partCell = document.createElement("td");
      partCell.className = "lpf-col-part";
      partCell.append(partBlock(item));
      const nameCell = document.createElement("td");
      nameCell.className = "lpf-col-product";
      nameCell.append(productBlock(item));
      row.append(imageCell, partCell, nameCell);
      if (showSpecs) {
        row.append(specCell(item.pitchLabel), specCell(item.gaugeLabel), specCell(item.driveLinks));
      }
      const cartCell = document.createElement("td");
      cartCell.className = "lpf-col-cart";
      cartCell.append(buyControls(item));
      row.append(cartCell);
      return row;
    }

    function specCell(value) {
      const cell = document.createElement("td");
      cell.className = "lpf-spec";
      cell.append(el("span", "lpf-pill", value || "—"));
      return cell;
    }

    function buildCard(item, showSpecs) {
      const card = el("div", "lpf-card-item");
      const top = el("div", "lpf-card-top");
      top.append(photoBox(item), partBlock(item));
      card.append(top, productBlock(item));
      if (showSpecs) {
        const grid = el("div", "lpf-spec-grid");
        grid.append(specBox("Pitch", item.pitchLabel), specBox("Gauge", item.gaugeLabel), specBox("Links", item.driveLinks));
        card.append(grid);
      }
      card.append(buyControls(item, true));
      return card;
    }

    function specBox(label, value) {
      const box = el("div", "lpf-spec-box");
      box.append(el("span", "", label), el("strong", "", value || "—"));
      return box;
    }

    function partBlock(item) {
      const block = el("div", "");
      const line = el("div", "lpf-part-line");
      const label = item.partNumber || "—";
      if (item.partNumber && item.productUrl) {
        const link = document.createElement("a");
        link.className = "lpf-part-num";
        link.href = item.productUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.textContent = label;
        line.append(link);
      } else {
        line.append(el("span", "lpf-part-num", label));
      }
      block.append(line);
      if (item.available === false) {
        const badges = el("div", "lpf-badges");
        badges.append(el("span", "lpf-stock", "Out of stock"));
        block.append(badges);
      }
      return block;
    }

    function productBlock(item) {
      const block = el("div", "lpf-product");
      let title;
      if (item.productUrl) {
        title = document.createElement("a");
        title.href = item.productUrl;
        title.target = "_blank";
        title.rel = "noopener noreferrer";
        title.className = "lpf-product-title";
      } else {
        title = el("h3", "lpf-product-title");
      }
      title.textContent = item.productName || "Product";
      block.append(title);
      const price = priceLine(item);
      if (price) block.append(price);
      for (const note of item.notes || []) block.append(el("p", "lpf-product-note", note));
      return block;
    }

    function priceLine(item) {
      if (item.price == null || item.price === "") return null;
      const price = Number(item.price);
      if (!Number.isFinite(price)) return null;
      const compare = item.compareAtPrice == null || item.compareAtPrice === "" ? NaN : Number(item.compareAtPrice);
      const onSale = Number.isFinite(compare) && compare > price;
      const row = el("div", onSale ? "lpf-price lpf-price--sale" : "lpf-price");
      if (onSale) {
        const was = el("s", "lpf-price-compare", formatMoney(compare));
        was.setAttribute("aria-label", `Regular price ${formatMoney(compare)}`);
        row.append(was);
      }
      const now = el("span", "lpf-price-current", formatMoney(price));
      if (onSale) now.setAttribute("aria-label", `Sale price ${formatMoney(price)}`);
      row.append(now);
      return row;
    }

    function photoBox(item) {
      const photo = el("div", "lpf-photo");
      if (item.imageUrl) {
        const image = document.createElement("img");
        image.src = item.imageUrl;
        image.alt = "";
        image.addEventListener("error", () => {
          photo.replaceChildren(el("span", "lpf-photo-empty", "No image"));
        });
        photo.append(image);
      } else {
        photo.append(el("span", "lpf-photo-empty", "No image"));
      }
      return photo;
    }

    function buyControls(item, wide) {
      const soldOut = item.available === false;
      const canAdd = Boolean(item.variantId) && !soldOut;
      const wrap = el("div", wide ? "lpf-buy lpf-buy--wide" : "lpf-buy");
      const qty = quantityControl(canAdd);
      wrap.append(qty, cartButton(item, wide, canAdd, soldOut, qty));
      return wrap;
    }

    function quantityControl(enabled) {
      const field = el("div", "lpf-qty");
      const down = el("button", "lpf-qty-btn", "−");
      down.type = "button";
      down.setAttribute("aria-label", "Decrease quantity");
      const input = document.createElement("input");
      input.type = "number";
      input.min = "1";
      input.max = "99";
      input.step = "1";
      input.value = "1";
      input.inputMode = "numeric";
      input.setAttribute("aria-label", "Quantity");
      const up = el("button", "lpf-qty-btn", "+");
      up.type = "button";
      up.setAttribute("aria-label", "Increase quantity");
      const setQty = (value) => {
        input.value = String(clampQty(value));
      };
      down.addEventListener("click", () => setQty(Number(input.value) - 1));
      up.addEventListener("click", () => setQty(Number(input.value) + 1));
      input.addEventListener("change", () => setQty(input.value));
      down.disabled = !enabled;
      up.disabled = !enabled;
      input.disabled = !enabled;
      field.append(down, input, up);
      field.input = input;
      return field;
    }

    function cartButton(item, wide, canAdd, soldOut, qty) {
      const name = item.productName || item.partNumber || "part";
      const button = el("button", wide ? "lpf-cart lpf-cart--wide" : "lpf-cart");
      button.type = "button";
      button.disabled = !canAdd;
      const label = soldOut ? "Out of stock" : canAdd ? "Add to cart" : "Unavailable";
      button.title = label;
      button.setAttribute(
        "aria-label",
        soldOut ? `${name} is out of stock` : canAdd ? `Add ${name} to cart` : `${name} cannot be added to cart`,
      );
      button.dataset.label = label;
      if (canAdd) button.append(icon("cart"));
      button.append(document.createTextNode(label));
      if (canAdd) button.addEventListener("click", () => addToCart(item, button, qty.input));
      return button;
    }

    async function addToCart(item, button, qtyInput) {
      if (button.disabled || button.classList.contains("is-adding")) return;
      const quantity = clampQty(qtyInput?.value);
      if (qtyInput) qtyInput.value = String(quantity);
      button.classList.add("is-adding");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      const idleLabel = button.dataset.label || "Add to cart";
      setCartLabel(button, "Adding...");
      const rootPath = window.Shopify?.routes?.root || "/";
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: cartVariantId(item.variantId), quantity }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          showToast(data.description || data.message || "This part could not be added to the cart.");
          return;
        }
        showToast("Added to cart");
        await refreshCart(rootPath);
      } catch {
        showToast("This part could not be added to the cart.");
      } finally {
        button.classList.remove("is-adding");
        button.disabled = false;
        button.removeAttribute("aria-busy");
        setCartLabel(button, idleLabel, true);
      }
    }

    function setCartLabel(button, label, withIcon) {
      button.replaceChildren();
      if (withIcon) button.append(icon("cart"));
      button.append(document.createTextNode(label));
    }

    async function refreshCart(rootPath) {
      try {
        const response = await fetch(`${rootPath}cart.js`, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) return;
        const cart = await response.json();
        applyCartCount(Number(cart.item_count) || 0);
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart } }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } }));
        if (window.jQuery) {
          window.jQuery(document).trigger("cart:updated", [cart]);
          window.jQuery(document).trigger("ajaxCart.afterCartLoad", [cart]);
        }
        // Halo / Themevale rebuilds the preview dropdown from Shopify.getCart on open.
        if (typeof window.Shopify?.getCart === "function") {
          window.Shopify.getCart((latest) => {
            applyCartCount(Number(latest?.item_count) || 0);
          });
        }
      } catch {
        // The line is already in the cart.
      }
    }

    function applyCartCount(count) {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = String(count);
      });
      document.querySelectorAll("[data-cart-count-bubble]").forEach((el) => {
        el.classList.toggle("hide", count <= 0);
        el.classList.toggle("hidden", count <= 0);
        if (count > 0) el.classList.remove("is-hidden");
      });
      document.querySelectorAll("[data-cart-popup-cart-quantity]").forEach((el) => {
        el.textContent = String(count);
      });
    }

    function renderSpecbar(sections) {
      const items = sections.flatMap((section) => (section.showSpecs ? section.items : []));
      const pitches = unique(items.map((item) => item.pitchLabel));
      const gauges = unique(items.map((item) => item.gaugeLabel));
      const links = unique(items.map((item) => item.driveLinks));
      if (!pitches.length && !gauges.length && !links.length) {
        specbar.hidden = true;
        specbar.replaceChildren();
        return;
      }
      const row = el("div", "lpf-specbar-items");
      if (pitches.length) row.append(specSummary("pitch", "Pitch:", pitches.map((value) => `${value} Chain Pitch`).join(", ")));
      if (gauges.length) row.append(specSummary("gauge", "Gauge:", gauges.map((value) => `${value} Drive Link Thickness`).join(", ")));
      if (links.length) row.append(specSummary("links", "Drive Links:", links.map((value) => /\bdl\b/i.test(value) ? value : `${value} DL`).join(", ")));
      specbar.replaceChildren(row, el("div", "lpf-ansi", "All parts comply with ANSI B175.1 standards"));
      specbar.hidden = false;
    }

    function specSummary(kind, label, value) {
      const item = el("div", "lpf-specbar-item");
      if (kind === "pitch") item.append(el("span", "lpf-specbar-tilde", "~"));
      else item.append(icon(kind));
      const text = el("span", "");
      text.append(el("strong", "", label), document.createTextNode(` ${value}`));
      item.append(text);
      return item;
    }

    function showError(message) {
      error.hidden = false;
      error.textContent = message;
    }
    function hideError() {
      error.hidden = true;
      error.textContent = "";
      brand.setInvalid(false);
      model.setInvalid(false);
      length.setInvalid(false);
    }

    let toastTimer;
    function showToast(message) {
      toast._text.textContent = message;
      toast.classList.add("is-on");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove("is-on"), 2400);
    }

    function combo(name, formStep, resultsStep, formLabel, resultsLabel, required) {
      const field = el("div", "lpf-field");
      const formRow = el("div", "lpf-label lpf-label-form");
      const formText = el("span", "lpf-label-text");
      formText.append(document.createTextNode(formStep ? ` ${formLabel}` : formLabel));
      if (required) formText.append(el("span", "lpf-req", "*"));
      formRow.append(formText, infoButton(name));

      const resultsRow = el("div", "lpf-label lpf-label-results");
      const resultsText = el("span", "lpf-label-text");
      const step = el("span", required ? "lpf-step" : "lpf-step is-optional", resultsStep);
      resultsText.append(step, document.createTextNode(resultsLabel));
      if (required) resultsText.append(el("span", "lpf-req", "*"));
      else resultsText.append(el("span", "lpf-optional", "optional"));
      resultsRow.append(resultsText, infoButton(name));

      const box = el("div", "lpf-combo");
      const input = document.createElement("input");
      input.type = "text";
      input.autocomplete = "off";
      input.spellcheck = false;
      input.setAttribute("role", "combobox");
      input.setAttribute("aria-autocomplete", "list");
      input.setAttribute("aria-expanded", "false");
      const anyLabel = name === "gauge" ? "Any gauge" : "Any pitch";
      input.placeholder = required ? formLabel : anyLabel;
      const tools = el("div", "lpf-combo-tools");
      const clearBtn = el("button", "lpf-clear", "✕");
      clearBtn.type = "button";
      clearBtn.setAttribute("aria-label", `Clear ${resultsLabel}`);
      const chevron = el("span", "lpf-chevron");
      chevron.append(icon("chevron"));
      const list = document.createElement("ul");
      list.className = "lpf-list";
      list.hidden = true;
      list.setAttribute("role", "listbox");
      tools.append(clearBtn, chevron);
      box.append(input, tools, list);
      field.append(formRow, resultsRow, box);

      let key = "";
      let active = 0;
      let disabled = false;
      const control = {
        field,
        onChange() {},
        getOptions() { return []; },
      };

      function options() { return control.getOptions(); }
      function filtered() {
        const query = fold(input.value);
        const all = options();
        if (!query || input.value === labelFor(key)) return all;
        return all.filter((item) => fold(item.label).includes(query) || item.label.toLowerCase().includes(input.value.trim().toLowerCase()));
      }
      function labelFor(next) {
        return options().find((item) => item.key === next)?.label || "";
      }
      function open() {
        if (disabled) return;
        renderList();
        list.hidden = false;
        input.setAttribute("aria-expanded", "true");
      }
      function close() {
        list.hidden = true;
        input.setAttribute("aria-expanded", "false");
      }
      function renderList() {
        const items = filtered();
        list.replaceChildren();
        active = Math.min(active, Math.max(items.length - 1, 0));
        if (!items.length) {
          const empty = document.createElement("li");
          empty.textContent = "No matches";
          empty.setAttribute("aria-disabled", "true");
          list.append(empty);
          return;
        }
        items.forEach((item, index) => {
          const option = document.createElement("li");
          option.setAttribute("role", "option");
          option.textContent = item.label;
          if (index === active) option.classList.add("is-active");
          if (item.key === key) option.setAttribute("aria-selected", "true");
          option.addEventListener("mousedown", (event) => {
            event.preventDefault();
            choose(item);
          });
          list.append(option);
        });
        list.querySelector(".is-active")?.scrollIntoView({ block: "nearest" });
      }
      function choose(item) {
        const changed = key !== item.key;
        key = item.key;
        input.value = item.label;
        close();
        if (changed) control.onChange(key);
      }
      input.addEventListener("focus", open);
      input.addEventListener("click", open);
      input.addEventListener("input", () => {
        active = 0;
        open();
      });
      input.addEventListener("keydown", (event) => {
        const items = filtered();
        if (event.key === "ArrowDown") {
          event.preventDefault();
          active = Math.min(active + 1, items.length - 1);
          open();
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          active = Math.max(active - 1, 0);
          open();
        } else if (event.key === "Enter") {
          if (!list.hidden && items[active]) {
            event.preventDefault();
            choose(items[active]);
          }
        } else if (event.key === "Escape") {
          input.value = labelFor(key);
          close();
        }
      });
      input.addEventListener("blur", () => {
        const exact = options().find((item) => item.label.toLowerCase() === input.value.trim().toLowerCase());
        if (exact) choose(exact);
        else input.value = labelFor(key);
        close();
      });
      clearBtn.addEventListener("click", () => {
        key = "";
        input.value = "";
        control.onChange("");
        input.focus();
      });
      document.addEventListener("click", (event) => {
        if (!field.contains(event.target)) close();
      });

      control.currentLabel = () => input.value.trim();
      control.setKey = (next) => {
        key = next || "";
        input.value = labelFor(key);
      };
      control.clear = () => {
        key = "";
        input.value = "";
      };
      control.setDisabled = (value) => {
        disabled = value;
        input.disabled = value;
        field.classList.toggle("is-disabled", value);
        if (value) close();
      };
      control.setInvalid = (value) => field.classList.toggle("is-invalid", value);
      control.setPresentation = (mode) => {
        field.classList.toggle("is-present-form", mode === "form");
        field.classList.toggle("is-present-results", mode === "results");
        input.placeholder = mode === "form" ? (required ? formLabel : anyLabel) : (required ? resultsLabel : anyLabel);
      };
      return control;
    }
  }

  function barSummary(value) {
    const match = String(value || "").match(/(\d+(?:\.\d+)?)\s*"?/);
    return match ? `${match[1]}" Bar` : value;
  }
  function lengthShort(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    if (raw.includes('"') || raw.includes("″")) return raw;
    const match = raw.match(/(\d+(?:\.\d+)?)/);
    return match ? `${match[1]}"` : raw;
  }
  function lengthPhrase(value) {
    const match = String(value || "").match(/(\d+(?:\.\d+)?)/);
    return match ? `${match[1]}-inch` : value;
  }
  function clampQty(value) {
    const number = Math.floor(Number(value));
    if (!Number.isFinite(number)) return 1;
    return Math.min(99, Math.max(1, number));
  }
  function formatMoney(cents) {
    const amount = Number(cents) / 100;
    const currency = window.Shopify?.currency?.active || "USD";
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amount);
    } catch {
      return `$${amount.toFixed(2)}`;
    }
  }
  function unique(values) {
    return [...new Set(values.filter(Boolean))];
  }
  function infoButton(name) {
    const wrap = el("div", "lpf-info-wrap");
    const button = el("button", "lpf-info");
    button.type = "button";
    button.setAttribute("aria-label", `About ${name}`);
    button.append(icon("info"));
    const tips = {
      brand: "Choose the manufacturer of your saw",
      model: "Enter your saw's model number",
      length: "Enter the cutting length of your guide bar",
      pitch: "Optional chain pitch preference.",
      gauge: "Optional chain gauge preference.",
    };
    wrap.append(button, el("p", "lpf-tip", tips[name]));
    return wrap;
  }
  function sawIcon() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 32 20");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("aria-hidden", "true");
    svg.innerHTML = '<rect x="2" y="4" width="22" height="12" rx="4"/><line x1="8" y1="10" x2="18" y2="10" stroke-linecap="round"/><circle cx="26" cy="10" r="2" fill="currentColor" stroke="none"/>';
    return svg;
  }
  function icon(name, className, strokeWidth) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", strokeWidth || "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden", "true");
    if (className) svg.setAttribute("class", className);
    svg.innerHTML = ICONS[name] || "";
    return svg;
  }
  function fold(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }
  function cartVariantId(value) {
    const id = String(value || "").trim();
    if (/^\d+$/.test(id) && Number(id) <= Number.MAX_SAFE_INTEGER) return Number(id);
    return id;
  }
  function replaceSection(id, html) {
    if (!html || typeof html !== "string") return;
    const existing = document.getElementById(`shopify-section-${id}`);
    if (!existing) return;
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    const next = template.content.querySelector(`#shopify-section-${id}`) || template.content.firstElementChild;
    if (next) existing.replaceWith(next);
  }
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  document.querySelectorAll(".lpf-app").forEach(initFinder);
})();
